import { render, staticRenderFns } from "./AdminKefu.vue?vue&type=template&id=47548899&scoped=true"
import script from "./AdminKefu.vue?vue&type=script&lang=js"
export * from "./AdminKefu.vue?vue&type=script&lang=js"
import style0 from "./AdminKefu.vue?vue&type=style&index=0&id=47548899&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47548899",
  null
  
)

export default component.exports